import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { BillingDetails } from './groupBillingClient.types';

class GroupBillingClient extends BaseClient {
    getBillingDetails(teamId: number, groupId: string): AxiosPromise<BillingDetails> {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing`);
    }

    updateInformation(teamId: number, groupId: string, data: Record<string, unknown>) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing/information`, 'put', data);
    }

    updateBillingEmail(teamId: number, groupId: string, data: { email: string }) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing/email`, 'put', data);
    }

    createSetupIntent(teamId: number, groupId: string) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing/setup-intent`, 'post');
    }

    updatePaymentMethod(teamId: number, groupId: string, stripePaymentMethod: string) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing/payment-method`, 'put', {
            stripe_payment_method: stripePaymentMethod,
        });
    }

    getProformaInvoice(teamId: number, groupId: string, periodDate?: string) {
        const params = periodDate ? { period_date: periodDate } : undefined;
        return this.makeCoreApiRequest(
            `/api/v3/teams/${teamId}/groups/${groupId}/billing/proforma-invoice`,
            'get',
            undefined,
            params
        );
    }

    getInvoices(teamId: number, groupId: string) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/groups/${groupId}/billing/invoices`);
    }
}

export default new GroupBillingClient();
